import React from 'react';
import css from './NoMeetings.css';

function NoMeetings() {
  return (
    <div className={css['container']}>
      <h1>No student check-ins for today.</h1>
      <img 
        src="../images/starfish/starfish_calendar.png"  
        aria-hidden="true"
        className={css['image']}
      />
    </div>
  );
}

export default NoMeetings;
